"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.AdvertiseWithUsComponent = void 0;

var _get4 = _interopRequireDefault(require("lodash/get"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Alert = _interopRequireDefault(require("angieslist-react-components/lib/Alert"));

var _Button = _interopRequireDefault(require("angieslist-react-components/lib/Button"));

var _Grid = _interopRequireDefault(require("angieslist-react-components/lib/Grid"));

var _Col = _interopRequireDefault(require("angieslist-react-components/lib/Col"));

var _Row = _interopRequireDefault(require("angieslist-react-components/lib/Row"));

var _compose = _interopRequireDefault(require("recompose/compose"));

var _pure = _interopRequireDefault(require("recompose/pure"));

var _getErrorMessage = _interopRequireDefault(require("angieslist-app-platform/lib/common/getErrorMessage"));

var _AdvertiseWithUsDynamic = require("./AdvertiseWithUsDynamic");

require("./advertiseWithUs.scss");

/* eslint-disable react/forbid-prop-types,react/require-default-props */
var AdvertiseWithUsComponent = function AdvertiseWithUsComponent(props) {
  var advertiseRequest = props.advertiseRequest,
      advertiseRequestWasSuccessful = props.advertiseRequestWasSuccessful,
      advertiseRequestError = props.advertiseRequestError,
      advertiseRequestPending = props.advertiseRequestPending,
      contactCountByTopCategoryError = props.contactCountByTopCategoryError,
      contactCountByTopCategoryResponse = props.contactCountByTopCategoryResponse,
      closeAlert = props.closeAlert,
      activityLocation = props.activityLocation,
      overrideDynamicCTA = props.overrideDynamicCTA,
      serviceProviderId = props.serviceProviderId,
      userId = props.userId;

  var _get3 = (0, _get4["default"])(contactCountByTopCategoryResponse, 'categoryGroupContacts', false),
      contactCount = _get3.contactCount;

  var eligibleForDynamicAdvertiseWithUsCTA = contactCount > 9 && !overrideDynamicCTA;
  return /*#__PURE__*/_react["default"].createElement(_Row["default"], null, /*#__PURE__*/_react["default"].createElement(_Col["default"], {
    xs: 12
  }, advertiseRequestError ? /*#__PURE__*/_react["default"].createElement(_Alert["default"], {
    bsStyle: "danger",
    onDismiss: closeAlert
  }, (0, _getErrorMessage["default"])(advertiseRequestError)) : null, advertiseRequestWasSuccessful ? /*#__PURE__*/_react["default"].createElement(_Alert["default"], {
    bsStyle: "success",
    onDismiss: closeAlert
  }, "Thank you for your interest in advertising with Angi. A representative will contact you shortly.") : null, eligibleForDynamicAdvertiseWithUsCTA && contactCountByTopCategoryResponse && !contactCountByTopCategoryError ? /*#__PURE__*/_react["default"].createElement(_AdvertiseWithUsDynamic.AdvertiseWithUsDynamic, {
    serviceProviderId: serviceProviderId,
    userId: userId,
    contactCountByTopCategoryResponse: contactCountByTopCategoryResponse,
    advertiseRequest: advertiseRequest,
    advertiseRequestPending: advertiseRequestPending,
    activityLocation: activityLocation
  }) : /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
    className: "advertise-with-us-v3"
  }, /*#__PURE__*/_react["default"].createElement(_Row["default"], {
    style: {
      display: 'flex',
      flexWrap: 'wrap',
      alignItems: 'center'
    }
  }, /*#__PURE__*/_react["default"].createElement(_Col["default"], {
    xs: 12,
    md: 6,
    id: "office-home--advertise-with-us"
  }, /*#__PURE__*/_react["default"].createElement("h4", {
    style: {
      marginTop: 0
    }
  }, "Tools To Help Your Business Grow"), /*#__PURE__*/_react["default"].createElement("p", {
    style: {
      marginBottom: 10
    },
    id: "office-home--advertise-with-us--text"
  }, "Angi Ads offers comprehensive advertising packages to help you reach more members and target the right work, at the right time.")), /*#__PURE__*/_react["default"].createElement(_Col["default"], {
    xs: 12,
    md: 3,
    mdOffset: 2
  }, /*#__PURE__*/_react["default"].createElement(_Button["default"], {
    bsStyle: "primary-office",
    bsSize: "small",
    id: "office-home--advertise-with-us--submit-request-button",
    onClick: function onClick() {
      return advertiseRequest(activityLocation, 'Generic CTA');
    },
    loading: advertiseRequestPending,
    disabled: advertiseRequestPending,
    style: {
      width: '100%'
    },
    flat: true
  }, "Advertise With Us"))))));
};

exports.AdvertiseWithUsComponent = AdvertiseWithUsComponent;
AdvertiseWithUsComponent.defaultProps = {
  advertiseRequestWasSuccessful: false,
  advertiseRequestError: false,
  advertiseRequestPending: false,
  contactCountByTopCategoryError: {},
  contactCountByTopCategoryResponse: {}
};

var _default = (0, _compose["default"])(_pure["default"])(AdvertiseWithUsComponent);

exports["default"] = _default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/angieslist-office-app-common/lib/v1/header/AdvertiseWithUs.js
// module id = 1928
// module chunks = 25